module.exports = __webpack_public_path__ + "media/images/social_services/fb_primary-ff7b6ebffd17a0dffb512171b4ee6f55.svg";